export const formatGhanaPhoneNumber = (phone) => {
  if (!phone) return "";
  const cleaned = String(phone).replace(/\D/g, "");
  if (cleaned.startsWith("233")) return cleaned.slice(0, 12);
  if (cleaned.startsWith("0")) return "233" + cleaned.slice(1, 10);
  if (cleaned.length === 9) return "233" + cleaned;
  return cleaned.startsWith("233") ? cleaned : "233" + cleaned;
};

export const validateGhanaPhoneNumber = (phone) => {
  if (!phone) return { isValid: false, message: "Phone number is required" };
  const formatted = formatGhanaPhoneNumber(phone);
  if (formatted.length !== 12) {
    return { isValid: false, message: "Phone number must be 12 digits (233XXXXXXXXX)" };
  }
  if (!formatted.startsWith("233")) {
    return { isValid: false, message: "Phone number must start with 233" };
  }
  const validPrefixes = ["20", "23", "24", "25", "26", "27", "28", "29", "50", "54", "55", "56", "57", "59"];
  const networkPrefix = formatted.substring(3, 5);
  if (!validPrefixes.includes(networkPrefix)) {
    return { isValid: false, message: "Invalid Ghana network prefix" };
  }
  return { isValid: true, message: "", formatted };
};

export const formatPhoneOnInput = (value) => {
  const cleaned = String(value || "").replace(/\D/g, "");
  if (cleaned.startsWith("233")) {
    if (cleaned.length <= 3) return "233";
    if (cleaned.length <= 5) return `233 ${cleaned.slice(3)}`;
    if (cleaned.length <= 8) return `233 ${cleaned.slice(3, 5)} ${cleaned.slice(5)}`;
    return `233 ${cleaned.slice(3, 5)} ${cleaned.slice(5, 8)} ${cleaned.slice(8, 12)}`;
  }
  if (cleaned.startsWith("0")) {
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 6) return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6, 10)}`;
  }
  return cleaned;
};

export const extractInitials = (fullName) => {
  if (!fullName) return "";
  const names = String(fullName).trim().split(/\s+/).filter((n) => n.length > 0);
  return names.map((n) => n.charAt(0).toUpperCase()).join(".");
};

export const generateSignatureFormat = (fullName) => {
  const initials = extractInitials(fullName);
  return initials ? `${initials}.` : "";
};

export const validateSignature = (signature, applicantName) => {
  if (!signature) return { isValid: false, message: "Signature is required" };
  if (!applicantName) return { isValid: false, message: "Please enter applicant name first" };
  const expectedFormat = generateSignatureFormat(applicantName);
  const normalizedSignature = String(signature).trim().toUpperCase().replace(/\s+/g, "").replace(/\.+$/, ".");
  const normalizedExpected = expectedFormat.toUpperCase().replace(/\s+/g, "");
  if (normalizedSignature !== normalizedExpected) {
    return { isValid: false, message: `Signature must be in format: ${expectedFormat}`, expectedFormat };
  }
  return { isValid: true, message: "", expectedFormat };
};
